import React from "react";

import * as Styled from "./styles";

import logo from "shared/assets/img/logo.png";
import { FaBook } from "react-icons/fa6";
import { LiaUserSlashSolid } from "react-icons/lia";
import { Container } from "@mui/material";

import { IoLocation } from "react-icons/io5";
import { isMobile } from "react-device-detect";
import { useMetrus } from "shared/providers";

const HeaderApp: React.FC = () => {
  const { isWebView } = useMetrus();

  return (
    <Styled.Container>
      <Container maxWidth={isMobile ? "md" : "xl"}>
        <Styled.Container>
          {isWebView ? (
            ""
          ) : (
            <Styled.LogoLink href="https://metrus.org.br/" target="_blank">
              <Styled.Image src={logo} />
            </Styled.LogoLink>
          )}
          <Styled.Access>
            {window.location.pathname === "/disqualified" ? (
              <Styled.ButttonHeader href="/">
                <IoLocation />
                <p>Rede de Atendimento</p>
              </Styled.ButttonHeader>
            ) : (
              <>
                <Styled.ButttonHeader
                  href="https://metrus.bennercloud.com.br/Portal/RedeAtendimento/GeraRelatorio"
                  target="_blank"
                >
                  <FaBook />
                  <p>Livreto de Saúde</p>
                </Styled.ButttonHeader>
                <Styled.ButttonHeader
                  href="https://metrus.bennercloud.com.br/Portal/public/redeatendimento/Descredenciados.aspx"
                  target="_blank"
                >
                  <LiaUserSlashSolid />
                  <p>Descredenciados</p>
                </Styled.ButttonHeader>
              </>
            )}
          </Styled.Access>
        </Styled.Container>
      </Container>
    </Styled.Container>
  );
};

export { HeaderApp };
